export default function formatData(data, metrics) {
  return data.reduce((_formattedData, chartData) => {
    const { name, values } = chartData;
    const formattedValues = metrics.reduce((formattedMetrics, metric, index) => {
      formattedMetrics[metric] = values[index];

      return formattedMetrics;
    }, {});

    const formattedData = [
      ..._formattedData,
      {
        name,
        ...formattedValues
      }
    ];

    return formattedData;
  }, []);
}
